import { FC } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";

import MainSection from "./components/MainSection";
import { ExploreBanner } from "components/Banner";
import Search from "./components/Search";
import HostHKTBanner from "./components/HostHKTBanner";
import LookingForMore from "./components/LookingForMore";

const HomePage: FC = () => {
  // const isLoggedIn = useAppSelector(getLoginState);
  return (
    <div className={styles.container}>
      <ExploreBanner />
      <Search />
      <div className={clsx(styles.root, "container")}>
        <MainSection />
      </div>
      <HostHKTBanner />
      <LookingForMore />
    </div>
  );
};

export default HomePage;
